// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 4H23V9.04148C21.5812 9.27953 20.5 10.5135 20.5 12C20.5 13.4865 21.5812 14.7205 23 14.9585V20H1V14.9585C2.41887 14.7205 3.50002 13.4865 3.50002 12C3.50002 10.5135 2.41887 9.27951 1 9.04148V4ZM16 11V9H8V11H16ZM16 15V13H8V15H16Z"}}]};

const TicketFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ticket-filled',
    ref,
    icon: element,
  },
));

TicketFilledIcon.displayName = 'TicketFilledIcon';

export default TicketFilledIcon;
